/** Public deployment identities shared by runtime-neutral adapters. */
export const PROD_CONVEX_CLOUD_URL = 'https://focused-dogfish-83.convex.cloud'
export const PROD_APP_ORIGIN = 'https://brew.new'
